export enum EnumDataLocation_CarKeys {
  Velocidad = "Velocidad",
  VoltajeBateria = "VoltajeBateria",
  Odometro = "Odometro",
  SenalDeRed = "SenalDeRed",
  StatusVehiculo = "StatusVehiculo",
  UltimaActualizacion = "UltimaActualizacion",
  StatusGPS = "StatusGPS",
  Direccion = "Direccion",
  Satelites = "Satelites",
  SerieGPS = "SerieGPS",
  VehicleUse = "VehicleUse",
  Alias = "Alias",
}